import { render } from "./PatientCreationForm.vue?vue&type=template&id=16ab508e&scoped=true&ts=true"
import script from "./PatientCreationForm.vue?vue&type=script&lang=ts"
export * from "./PatientCreationForm.vue?vue&type=script&lang=ts"

import "./PatientCreationForm.vue?vue&type=style&index=0&id=16ab508e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ab508e"]])

export default __exports__